import { globalStore, uiStore, documentStore } from "../../store/store";
import { saveToWordPressWithErrorsLoggedToUiStore } from "@/lib/wordpress/save";
import { pasteElements } from "@/lib/design-library/design-library";
import { breakdanceUndo } from "@/lib/undo/undo";
import { rewriteContentInSection } from "@/subapps/onboarding/lib/ai";
import { shuffleSection } from "@/subapps/onboarding/lib/pages";
import { toggleSectionColors } from "@/subapps/onboarding/lib/color";

export async function handleIframeMessageFromOnboardingApp(
  event: MessageEvent
) {
  if (event.origin !== window.location.origin) {
    console.warn("Message received from untrusted origin:", event.origin);
    return;
  }

  const message = event.data as {
    id?: string;
    type: string;
    payload: { action: string; data?: any };
  };

  const { id, type, payload } = message;

  if (type !== "REQUEST" || !id || !payload?.action) return;

  try {
    switch (payload.action) {
      case "saveDocumentToWordPress":
        await saveToWordPressWithErrorsLoggedToUiStore();

        break;

      case "updateGlobalSettingsPerPath":
        breakdanceUndo.ignore(async () => {
          globalStore.updateGlobalSettingsPerPath(payload.data);
        });

        break;

      case "updateBreakpoint":
        breakdanceUndo.ignore(async () => {
          uiStore.changeBreakpoint(payload.data.breakpoint);
        });

        break;

      case "importSectionFromOnboarding":
        pasteElements(
          [payload.data.sectionTree],
          "pasting",
          {},
          {
            mode: "replace",
            targetElementId:
              uiStore.activeElementId || payload.data.targetElementId
          }
        );

        break;

      case "onboardingActivateElement":
        breakdanceUndo.ignore(async () => {
          uiStore.activateElement(payload.data.elementId);
        });

        break;

      case "updateSectionPrompt":
        documentStore.unthrottledPropertyChanged({
          elementId: payload.data.elementId,
          path: "meta.promptInfo.sectionDescription",
          meta: {
            snapshotLabel: `Updated prompt info for element`
          },
          value: payload.data.sectionDescription
        });

        await rewriteContentInSection(payload.data.elementId);

        break;

      case "shuffleSection":
        shuffleSection(payload.data.elementId);

        break;
      case "toggleSectionColors":
        toggleSectionColors(payload.data.elementId, payload.data.colorGroup);

        break;

      default:
        throw new Error(`Unknown action: ${payload.action}`);
    }

    const result = {
      activeElementId: uiStore.activeElementId,
      document: documentStore.document
    };

    window.parent.postMessage(
      {
        id,
        type: "RESPONSE",
        payload: {
          success: true,
          payload: result
        }
      },
      event.origin
    );
  } catch (err: any) {
    window.parent.postMessage(
      {
        id,
        type: "RESPONSE",
        payload: {
          success: false,
          error: err.message || "Unknown iframe error"
        }
      },
      event.origin
    );
  }
}
